import { atom } from 'jotai'
import { MEETING_STATES } from 'app/config/meeting'

export const isAvailableMicroAtom = atom<boolean>(false)
export const meetingStateAtom = atom<string>(MEETING_STATES.PENDING)
